import { OnInit, Component } from '@angular/core';
import { AuthenticationService, TokenPayload, TestData, errorData} from '../services/authentication.service';
import { Router } from '@angular/router';
import { NgForm, FormBuilder, FormGroup, Validators } from '@angular/forms';
import {MediaMatcher} from '@angular/cdk/layout';
import {ChangeDetectorRef} from '@angular/core';
import { TestSchedulerService } from '../services/test_scheduler.service';
import Swal from 'sweetalert2';



@Component({
  templateUrl: './createTestScheduler.component.html',
  styleUrls: [ './createTestScheduler.component.scss' ]
})
export class CreateTestSchedulerComponent implements OnInit {
  credentials: TokenPayload = {
    id: '',
    first_name: '',
    last_name: '',
    email: '',
    password: '',
    // confirmpassword: '',
    phone: '',
    type: '',
    
  };

  errors : errorData = {
    first_name: false,
    last_name: false,
    email: false,
    password: false,
    phone: false,
    phone_number: false,
    email_id : false
  }

  registerForm: FormGroup;
  submitted = false;
  result: string[];
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  details: boolean;
  overall: boolean;

  questionset: boolean;
  scheduletest: boolean;
  evaluate: boolean;
  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };
  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;
  links = ['Super Admin', 'Admin', 'Test Scheduler', 'Test Taker'];
  email;
  user;
  fname;
  lname;
  columns: string[];
  errorCounter: number;
  hostNameFromWeb: string;
  hostNameProtocol: string;
  actualHostName: string;
  userEvaluator: boolean;
    constructor(private auth: AuthenticationService, private router: Router, private formBuilder: FormBuilder,
                private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher) {

      this.simpletest();
      this.mobileQuery = media.matchMedia('(max-width: 600px)');
      this._mobileQueryListener = () => changeDetectorRef.detectChanges();
      this.mobileQuery.addListener(this._mobileQueryListener);
                }

    ngOnInit() {
      this.registerForm = this.formBuilder.group({
          first_name: ['', Validators.required],
          last_name: ['', Validators.required],
          email: ['', [Validators.required, Validators.email]],
          // password: ['', [Validators.required, Validators.minLength(5)]],
          // confirmpassword: ['', [Validators.required, Validators.minLength(10)]],
          phone: ['', [Validators.required, Validators.minLength(9) ]]
      });

      this.hostNameProtocol = window.location.protocol 
      this.hostNameFromWeb = window.location.host
      this.actualHostName = this.hostNameProtocol.concat("//",this.hostNameFromWeb)
      console.log("Printing the hostname inside the create test Scheduler component",this.actualHostName);
      this.getAccess();

  }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');

    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  get f() {
    return this.registerForm.controls;
  }

  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
    (data) => {


     this.user = sessionStorage.getItem('user');
     this.fname = sessionStorage.getItem('fname');

     this.lname = sessionStorage.getItem('lname');


     if (this.user === '2') {

      this.userAdmin = true;
      this.userSuperAdmin = false;
      this.result = data.results;
      return this.result;
     } else if ( this.user === '1') {
      this.userAdmin = true;
      this.userSuperAdmin = true;
      this.result = data.results;
      return this.result;
     } else if ( this.user === '3') {
      this.userTestScheduler = true;
     } else if ( this.user === '4') {
      this.userAdmin = false;
      this.userSuperAdmin = false;
      this.userTestScheduler = false;
      this.userTestTaker = false;
      this.questionset = true;
      this.scheduletest = true;
      this.overall = true;
      this.evaluate = true;
      this.details = false;
     }
    },
    err => {
      console.error(err);
    }
  );
}
validateFields(){
  let EMAIL_REGEXP = /^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i;
  this.errorCounter = 0;
  if(this.credentials)
  {

    if(this.credentials.first_name === '')
    {
      this.errors.first_name = true;
      this.errorCounter=  this.errorCounter + 1
    }
    else{
      this.errors.first_name = false
    }
    if(this.credentials.last_name === '')
    {
      this.errors.last_name = true
      this.errorCounter=  this.errorCounter + 1
    }
    else{
      this.errors.last_name = false
    }
    // if(this.credentials.password === '')
    // {
    //   this.errors.password = true
    //   this.errorCounter=  this.errorCounter + 1
    // }
    // else{
    //   this.errors.password = false
    // }
    if(this.credentials.phone === '')
    {
      this.errors.phone = true
      this.errorCounter=  this.errorCounter + 1
    }
    else{
      this.errors.phone = false
    }
    if(this.credentials.phone !== '')
    {
    if(this.credentials.phone.length < 10 || this.credentials.phone.length > 10 )
    {
      this.errors.phone_number = true
      this.errorCounter=  this.errorCounter + 1
    }
    else{
      this.errors.phone_number = false
    }
    }
    if (this.credentials.email !== ""){
      this.errors.email = false
      if(this.credentials.email.length <= 5 || !EMAIL_REGEXP.test(this.credentials.email))
      {
        this.errors.email_id = true
        this.errorCounter=  this.errorCounter + 1
      }
      else{
        this.errors.email_id = false
      }
    }
    else
    {
       this.errors.email = true
       this.errorCounter=  this.errorCounter + 1
    }
  }
  return this.errors
}

  createTestScheduler() {
    console.log("inside createTestScheduler")
    
    this.submitted = true;

    this.validateFields();
    console.log("inside createTestScheduler 2",this.errorCounter )
    if (this.errorCounter === 0) {
      this.testschedulerservice.createTestScheduler(this.credentials,this.actualHostName).subscribe(
        (data) => {
          if (data.code === 200) {
            Swal.fire({
              title: 'Success',
              text: data.success,
              icon: 'success',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                this.router.navigateByUrl('/test_scheduler');
              }
            })
            
          } else {
            Swal.fire({
              title: 'Alert',
              text: data.failed,
              icon: 'warning',
              showCancelButton: false,
              confirmButtonText: 'OK'
            }).then((result) => {
              if (result.isConfirmed) {
                // this.router.navigateByUrl('/test_scheduler');
              }
            })
        }

        },
        err => {
          console.error(err);
        }
      );
      }
    }
    

    Oncancel() {
      this.router.navigateByUrl('/test_scheduler');
    }
 }
